import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { ComputerequipmentService } from './computerequipment.service';
@Component({
  selector: 'app-computerequipment',
  
  templateUrl: './computerequipment.component.html',
  styleUrl: './computerequipment.component.scss'
})
export class ComputerequipmentComponent {
  computerequipmentform: FormGroup; isJump: any;
  ComputerEquipmentId: any;
  APPeriodId: any;
  tangibleAssetsValidation: any;
  NormalRoutng: boolean;
  showBubbledata: any
  constructor(private formbuilder: FormBuilder, public commonService: CommonService, private equipmentservice: ComputerequipmentService, private router: Router, public sidenav: SideNavService) {
  }
  ngOnInit() {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.createvehicles();
    this.getvehicle(this.APPeriodId);
    this.isJump = localStorage.getItem('isJump')
    if (localStorage.getItem("SubmitStatus") == "true")
      this.computerequipmentform.disable()
    this.clearfield();
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true);
        this.getlastyeardata()
      }
    })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})
  }

  createvehicles() {
    this.computerequipmentform = this.formbuilder.group({
      APPeriodId: new FormControl(),
      ComputerEquipmentId: new FormControl(),
      MasterId: new FormControl(),
      PropertyPlantEquipmentGrossCost_End: new FormControl(),
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_End: new FormControl(),
      PropertyPlantEquipment_Start: new FormControl(),
      PropertyPlantEquipment_End: new FormControl(),
      TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment: new FormControl(),
      DisposalsPropertyPlantEquipment: new FormControl(),
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start: new FormControl(),
      IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment: new FormControl(),
      DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment: new FormControl(),
      PropertyPlantEquipmentGrossCost_Start: new FormControl(),
      ComputerEquipmentPropertyPlantEquipmentFreeøtextComment: new FormControl(),
      CreatedBy: new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.computerequipmentform.reset()
      }
    })
  }

  Insertvehicles() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.computerequipmentform.controls['APPeriodId'].setValue(this.APPeriodId)
    this.computerequipmentform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
    const formdata = this.computerequipmentform.getRawValue();
    if (this.ComputerEquipmentId) {
      this.computerequipmentform.controls['ComputerEquipmentId'].setValue(this.ComputerEquipmentId)
    }
    this.equipmentservice.insertcomputerequipment(formdata).subscribe((data) => {
      this.computerequipmentform.markAsPristine()
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Computer Equipment", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'computerequipment') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })

  }
  getvehicle(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.equipmentservice.getcomputerequipment(this.APPeriodId).subscribe((data: any) => {
      if (data) {
        this.computerequipmentform.patchValue(data);
        this.ComputerEquipmentId = data.ComputerEquipmentId
      }
      this.commonService.getNotesData();
      this.commonService.gettotaltanagable()
      this.computerequipmentform.controls['PropertyPlantEquipmentGrossCost_End'].disable();
      this.computerequipmentform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_End'].disable();
      this.computerequipmentform.controls['PropertyPlantEquipment_Start'].disable();
      this.computerequipmentform.controls['PropertyPlantEquipment_End'].disable();
      this.computerequipmentform.controls['TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment'].disable();
      this.computerequipmentform.controls['DisposalsPropertyPlantEquipment'].disable();
      this.computerequipmentform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start'].disable();
      this.computerequipmentform.controls['IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
      this.computerequipmentform.controls['DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
      this.computerequipmentform.controls['PropertyPlantEquipmentGrossCost_Start'].disable();
      this.costcalculations();
      this.depreciation();
    })
  }

  getlastyeardata() {

    this.equipmentservice.getcomputerequipmentLY(this.APPeriodId).subscribe((data: any) => {
      debugger
      this.showBubbledata = data;

      this.computerequipmentform.controls['PropertyPlantEquipment_End'].setValue(data.PropertyPlantEquipment_End)

    })
  }

  save() {
    debugger
    //if (this.validations()) {
    if (true) {
      this.Insertvehicles();
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  back() {
    debugger
    this.computerequipmentform.markAsPristine()
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Computer Equipment", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  costcalculations() {
    //const propertyPlantEquipmentGrossCost_End = +this.computerequipmentform.get("PropertyPlantEquipmentGrossCost_Start").value;
    //const accumulatedDepreciationImpairmentPropertyPlantEquipment_End = +this.computerequipmentform.get("TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment").value;
    //const propertyPlantEquipment_Start = +this.computerequipmentform.get("DisposalsPropertyPlantEquipment").value;
    //const total = propertyPlantEquipmentGrossCost_End + accumulatedDepreciationImpairmentPropertyPlantEquipment_End;
    //this.computerequipmentform.get("PropertyPlantEquipmentGrossCost_End").setValue(total - propertyPlantEquipment_Start);
    //this.computerequipmentform.get("PropertyPlantEquipment_Start").setValue(this.computerequipmentform.get("PropertyPlantEquipmentGrossCost_End").value - this.computerequipmentform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);
  }
  depreciation() {
    //const totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment = +this.computerequipmentform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start").value;
    //const disposalsPropertyPlantEquipment = +this.computerequipmentform.get("IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const accumulatedDepreciationImpairmentPropertyPlantEquipment_Start = +this.computerequipmentform.get("DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const total = totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment + disposalsPropertyPlantEquipment;
    //this.computerequipmentform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").setValue(total - accumulatedDepreciationImpairmentPropertyPlantEquipment_Start);
    //this.computerequipmentform.get("PropertyPlantEquipment_Start").setValue(this.computerequipmentform.get("PropertyPlantEquipmentGrossCost_End").value - this.computerequipmentform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);
  }


  validations() {
    debugger
    if (((this.computerequipmentform.controls['PropertyPlantEquipment_Start'].value == "" || this.computerequipmentform.controls['PropertyPlantEquipment_Start'].value == null) ? 0 : parseFloat(this.computerequipmentform.controls['PropertyPlantEquipment_Start'].value))
      + this.commonService.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_Start + this.commonService.tangibleAssetsValidation.Plantmachinery_PropertyPlantEquipment_Start +
      this.commonService.tangibleAssetsValidation.Officeequipment_PropertyPlantEquipment_Start + this.commonService.tangibleAssetsValidation.Furniturefittings_PropertyPlantEquipment_Start != ((this.commonService.tangibleAssetsValidation.BalanceSheet_CY == null || this.commonService.tangibleAssetsValidation.BalanceSheet_CY == undefined) ? 0 : this.commonService.tangibleAssetsValidation.BalanceSheet_CY)) {
      Swal.fire("Andica Accounts Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.EndDate + " is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.StartYear + " both values must match. ", 'warning')
      return false
    }
    if (((this.computerequipmentform.controls['PropertyPlantEquipment_End'].value == "" || this.computerequipmentform.controls['PropertyPlantEquipment_End'].value == null) ? 0 : parseFloat(this.computerequipmentform.controls['PropertyPlantEquipment_End'].value))
      + this.commonService.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_End + this.commonService.tangibleAssetsValidation.Plantmachinery_PropertyPlantEquipment_End +
      this.commonService.tangibleAssetsValidation.Officeequipment_PropertyPlantEquipment_End + this.commonService.tangibleAssetsValidation.Furniturefittings_PropertyPlantEquipment_End != ((this.commonService.tangibleAssetsValidation.BalanceSheet_LY == null || this.commonService.tangibleAssetsValidation.BalanceSheet_LY == undefined) ? 0 : this.commonService.tangibleAssetsValidation.BalanceSheet_LY)) {
      Swal.fire("Andica Accounts Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.LastyearEndDate + " is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.LastYear + " both values must match. ", 'warning')
      return false
    }
    else {
      return true
    }

  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.computerequipmentform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.save())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }
}
